import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";

const MoneyInput = ({ value, onChange }) => {
    const [isPositive, setIsPositive] = useState(true); // Управляет "+"/"-"
    const [amount, setAmount] = useState(value ? Math.abs(value) / 100 : ""); // Инициализация суммы

    // Переключение знака "+/-"
    const toggleSign = () => {
        setIsPositive(!isPositive);
        if (onChange) {
            const updatedValue = amount ? Number(amount) * 100 * (isPositive ? -1 : 1) : 0;
            onChange(updatedValue);
        }
    };

    // Обработка изменения суммы
    const handleAmountChange = (event) => {
        const value = event.target.value.replace(/\D/g, ""); // Убираем все, кроме цифр
        setAmount(value);
        if (onChange) {
            const updatedValue = value ? Number(value) * 100 * (isPositive ? 1 : -1) : 0;
            onChange(updatedValue);
        }
    };

    return (
        <Box display="flex" alignItems="center" gap={1} sx={{ justifyContent: "center" }}>
            {/* Переключатель знака */}
            <Typography
                sx={{
                    cursor: "pointer",
                    color: isPositive ? "green" : "red",
                    fontSize: "2rem",
                    userSelect: "none",
                }}
                onClick={toggleSign}
            >
                {isPositive ? "+" : "-"}
            </Typography>

            {/* Поле ввода суммы */}
            <TextField
                value={amount}
                onChange={handleAmountChange}
                variant="standard"
                inputProps={{
                    style: {
                        textAlign: "center",
                        fontSize: "2rem",
                        width: `${Math.max(3, amount.length)}ch`,
                        maxWidth: "15ch",
                    },
                }}
                sx={{
                    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                        display: "none",
                    },
                    "& input": {
                        padding: 0,
                    },
                }}
            />

            <Box
                sx={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    minWidth: "auto",
                    padding: 0,
                    cursor: "pointer",
                }}
            >₽</Box>
        </Box>
    );
};

export default MoneyInput;
